import { hasIn, union } from 'lodash';
import { combineReducers } from 'redux';

export function byIdReducerTemplate(entityName) {
  return function(state = {}, action) {
    if (hasIn(action, ['normalizedData', 'entities', entityName])) {
      return {
        ...state,
        ...action.normalizedData.entities[entityName],
      };
    } else {
      return state;
    }
  };
}

export function allIdsReducerTemplate(actionTypes) {
  return function(state = [], action) {
    if (actionTypes.includes(action.type)) {
      const { normalizedData } = action;
      return [...state, normalizedData.result];
    } else {
      return state;
    }
  };
}

export function entityAllIdsReducerTemplate(entityName) {
  return function(state = [], action) {
    if (hasIn(action, ['normalizedData', 'entities', entityName])) {
      const entityIds = Object.keys(action.normalizedData.entities[entityName]);
      return union(state, entityIds);
    } else {
      return state;
    }
  };
}

export function staticEntityByIdsTemplate(entityName) {
  return function(state = {}, action) {
    if (hasIn(action, ['normalizedData', 'entities', entityName])) {
      return {
        ...action.normalizedData.entities[entityName],
        ...state, // Here we override with the EXISTING elements to maintain referential equality.
      };
    } else {
      return state;
    }
  };
}

export function staticEntityReducerTemplate(entityName, actionTypes) {
  return combineReducers({
    byId: staticEntityByIdsTemplate(entityName),
    allIds: entityAllIdsReducerTemplate(entityName),
  });
}



// WEBPACK FOOTER //
// ./src/reducers/reducerUtils.js